import React from 'react';
import { Helmet } from 'react-helmet-async';
import ServiceSidebar from './ServiceSidebar';
import './Service.css';

const OocytePickup = () => {
  return (
    <div className="service-page">

      {/* ✅ SEO START */}
      <Helmet>
        <title>Oocyte Pickup in Ambala | Egg Retrieval IVF Procedure | Amaanat IVF</title>

        <meta
          name="description"
          content="Oocyte pickup (egg retrieval) in Ambala at Amaanat IVF. Safe and precise IVF procedure performed under sedation with high success rates."
        />

        <link rel="canonical" href="https://amaanativf.com/services/oocyte" />

        {/* ✅ Medical Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "MedicalProcedure",
            "name": "Oocyte Pickup",
            "description": "Egg retrieval procedure during IVF treatment",
            "procedureType": "Surgical",
            "bodyLocation": "Ovaries",
            "location": {
              "@type": "MedicalClinic",
              "name": "Amaanat IVF",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Ambala",
                "addressCountry": "India"
              }
            }
          })}
        </script>

        {/* ✅ FAQ Schema */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "What is oocyte pickup?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oocyte pickup is a procedure to collect eggs from the ovaries during IVF treatment."
                }
              },
              {
                "@type": "Question",
                "name": "Is oocyte pickup painful?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "The procedure is done under sedation, making it painless and comfortable."
                }
              },
              {
                "@type": "Question",
                "name": "How long does egg retrieval take?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Oocyte pickup usually takes around 15–20 minutes."
                }
              }
            ]
          })}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section className="service-hero">
        <div className="container">

          <h1>Oocyte Pickup in Ambala</h1>

          <p>
            Safe and precise egg retrieval procedure in IVF treatment
          </p>

          <div className="hero-stats">
            <span>20 min</span> Procedure Time
          </div>

        </div>
      </section>

      {/* MAIN */}
      <div className="services-layout container">

        <ServiceSidebar />

        <div className="services-content">

          <section>
            <h2>What is Oocyte Pickup in IVF?</h2>
            <p>
              Oocyte pickup is a minor surgical procedure used to retrieve eggs
              from the ovaries during IVF treatment. It is a crucial step in the IVF process.
            </p>
          </section>

          <section>
            <h2>Oocyte Pickup Procedure</h2>
            <p>
              The procedure is performed under sedation using ultrasound guidance.
              It is quick, painless, and ensures safe egg collection for fertilization.
            </p>
          </section>

          {/* ✅ Hidden SEO Block */}
          <section style={{ marginTop: "40px" }}>
            <h2>Best Oocyte Pickup Centre in Ambala</h2>
            <p>
              Amaanat IVF provides advanced oocyte pickup procedures in Ambala using
              modern technology and expert embryologists. Our safe and precise techniques
              ensure optimal egg retrieval for successful IVF outcomes.
            </p>
          </section>

        </div>
      </div>
    </div>
  );
};

export default OocytePickup;